export const jacketBodyColors = [
  {
    title: 'White',
    hex: '#f6f7e4'
  },
  {
    title: 'Black',
    hex: '#080605'
  },
  {
    title: 'Heather Gray',
    hex: '#6b6b65'
  },
  {
    title: 'Maroon',
    hex: '#511e26'
  },
  {
    title: 'Burgundy',
    hex: '#5a0711'
  },
  {
    title: 'Crimson',
    hex: '#a00d1e'
  },
  {
    title: 'Texas Orange',
    hex: '#a04f11'
  },
  {
    title: 'Burnt Orange',
    hex: '#df5900'
  },
  {
    title: 'Old Gold',
    hex: '#c6a00c'
  },
  {
    title: 'Athletic Gold',
    hex: '#ffc004'
  },
  {
    title: 'Hunter Green',
    hex: '#0e4d1c'
  },
  {
    title: 'Kelly Green',
    hex: '#007a3d'
  },
  {
    title: 'Dark Navy',
    hex: '#04152d'
  },
  {
    title: 'Navy',
    hex: '#072252'
  },
  {
    title: 'Royal',
    hex: '#0c1975'
  },
  {
    title: 'Columbia Blue',
    hex: '#3a75c4'
  },
  {
    title: 'Purple',
    hex: '#32004b'
  },
  {
    title: 'Light Purple',
    hex: '#491072'
  },
  {
    title: 'Brown',
    hex: '#593d2b'
  },
];

export const sleevesColors = [
  {
    title: 'White Leather',
    hex: '#ffffff'
  },
  {
    title: 'Black Leather',
    hex: '#3d332b'
  },
  {
    title: 'Gray Leather',
    hex: '#777772'
  },
  {
    title: 'Maroon Leather',
    hex: '#511e26'
  },
  {
    title: 'Red Leather',
    hex: '#a00d1e'
  },
  {
    title: 'Burnt Orange Leather',
    hex: '#d14414'
  },
  {
    title: 'Old Gold Leather',
    hex: '#c6a00c'
  },
  {
    title: 'Vegas Gold Leather',
    hex: '#bc9a5f'
  },
  {
    title: 'Athletic Gold Leather',
    hex: '#fca311'
  },
  {
    title: 'Hunter Green Leather',
    hex: '#2b4c3f'
  },
  {
    title: 'Kelly Green Leather',
    hex: '#016b34'
  },
  {
    title: 'Navy Leather',
    hex: '#353842'
  },
  {
    title: 'Royal Leather',
    hex: '#0c1975'
  },
  {
    title: 'Columbia Blue Leather',
    hex: '#607c8c'
  },
  {
    title: 'Purple Leather',
    hex: '#2b2147'
  },
  {
    title: 'Brown Leather',
    hex: '#493533'
  },
  {
    title: 'Cream Leather',
    hex: '#f0dc91'
  },
];

export const patchColors = [
  {
    title: 'White',
    hex: '#ffffff'
  },
  {
    title: 'Black',
    hex: '#080605'
  },
  {
    title: 'Gray',
    hex: '#777772'
  },
  {
    title: 'Light Gray',
    hex: '#a5a5a5'
  },
  {
    title: 'Maroon',
    hex: '#3e171d'
  },
  {
    title: 'Burgundy',
    hex: '#5a0711'
  },
  {
    title: 'Crimson',
    hex: '#a00d1e'
  },
  {
    title: 'Scarlet',
    hex: '#ce1126'
  },
  {
    title: 'Pink',
    hex: '#ff9ec9'
  },
  {
    title: 'Burnt Orange',
    hex: '#df5900'
  },
  {
    title: 'Orange',
    hex: '#f74902'
  },
  {
    title: 'Old Gold',
    hex: '#c6a00c'
  },
  {
    title: 'Vegas Gold',
    hex: '#bcad75'
  },
  {
    title: 'Athletic Gold',
    hex: '#fca311'
  },
  {
    title: 'Yellow Gold',
    hex: '#fcd116'
  },
  {
    title: 'Hunter Green',
    hex: '#0e4d1c'
  },
  {
    title: 'Kelly Green',
    hex: '#007a3d'
  },
  {
    title: 'Navy',
    hex: '#072252'
  },
  {
    title: 'Royal',
    hex: '#0c1975'
  },
  {
    title: 'Columbia Blue',
    hex: '#3a75c4'
  },
  {
    title: 'Purple',
    hex: '#32004b'
  },
  {
    title: 'Light Purple',
    hex: '#370e77'
  },
  {
    title: 'Brown',
    hex: '#593d2b'
  },
];

export function rgb2hex (_rgb) {
  /* eslint-disable prefer-template */
  const rgb = _rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
  return (rgb && rgb.length === 4) ? '#'
    + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2)
    + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2)
    + ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
  /* eslint-enable */
}
